import {
  readVehicleContext,
  writeVehicleContext,
  clearVehicleContext as clearVehicleContextStorage,
} from '@/utils/vehicleContextStorage'

export default {
  namespaced: true,

  state: () => ({
    domain: null,
    category: null,
    subcategory: null,
    vehicle: null,
  }),

  getters: {
    category(state) {
      return state.category
    },
    domain(state) {
      return state.domain
    },
    subcategory(state) {
      return state.subcategory
    },
    vehicle(state) {
      return state.vehicle
    },
  },

  mutations: {
    SET_DOMAIN(state, domain) {
      state.domain = domain
    },
    SET_CATEGORY(state, category) {
      state.category = category
    },
    SET_SUBCATEGORY(state, subcategory) {
      state.subcategory = subcategory
    },
    SET_VEHICLE(state, vehicle) {
      state.vehicle = vehicle
    },
  },

  actions: {
    async setDomain({ commit }, domain) {
      commit('SET_DOMAIN', domain)
    },

    async setCategory({ commit }, category) {
      commit('SET_CATEGORY', category)
    },

    async setSubCategory({ commit }, subcategory) {
      commit('SET_SUBCATEGORY', subcategory)
    },

    setVehicleContext({ commit }, context) {
      commit('SET_VEHICLE', context)
      writeVehicleContext(context)
    },

    clearVehicleContext({ commit }) {
      commit('SET_VEHICLE', null)
      clearVehicleContextStorage()
    },

    loadVehicleContext({ commit }) {
      if (!process.client) return
      commit('SET_VEHICLE', readVehicleContext())
    },
  },
}
